import { SupportedCompanies } from '@apparel/core/platform';
import { usePlatform } from '@apparel/react/platform/usePlatform';

export const GetCompanyTitle = (): string => {
    const platform = usePlatform();

    let title = 'Wooter';
    if (platform.getCompany() === SupportedCompanies.GAMEBREAKER) {
        title = 'Gamebreaker';
    } else if (platform.getCompany() === SupportedCompanies.P3INC) {
        title = 'P3inc';
    }

    return title;
};

export enum GTag {
    Add_to_cart = 'kdcSCIWAkYgDEImtzboB',
    Design_Request_Started = '6LoaCPaIkYgDEImtzboB',
    SignUp = 'abJACNSmu4gDEImtzboB',
    Design_Request_Selected_Quantities = 'V3dMCMywu4gDEImtzboB',
    Design_Request_Select_Colors = 'biIKCJC2u4gDEImtzboB',
    Design_Request_Submit_Description = 'Js1DCIu6u4gDEImtzboB',
    Order_Payment_method_Added = 'T7O4CP_au4gDEImtzboB',
    Design_Request_Select_Products = '9JAfCI_-wYgDEImtzboB',
    Design_Request_Uploaded_Media = '6Th7CI2UwogDEImtzboB',
    Design_Request_Submitted = 'b9pFCIWYwogDEImtzboB',
    Order_Purchased = 'Zz1KCOm9kYgDEImtzboB',
}

export enum GOOGLE_ANALYTIC_SERVICE {
    BEGIN_CHECKOUT = 'begin_checkout',
    ADD_TO_CART = 'add_to_cart',
    PURCHASE = 'purchase',
    NEW_FORM_SUBMISSION = 'New_Form_Submission',
}
